import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { deleteJob } from '../features/jobs/jobsSlice'

export default function JobItem({ job }) {
    const dispatch = useDispatch()
    const { id, title, salary, type, deadline } = job || {}
    const [background, setBackground] = useState("")

    useEffect(() => {
        if (type?.toLowerCase() === "internship") {
            setBackground("#FF5757")
        } else if (type?.toLowerCase() === "remote") {
            setBackground("#56E5C4")
        } else if (type?.toLowerCase() === "full time") {
            setBackground("#FF8A00")
        } else {
            setBackground("")
        }
    }, [type])

    function deleteJobInfo() {
        dispatch(deleteJob(id))
    }
    return (
        <div className="lws-single-job">
            <div className="flex-1 min-w-0">
                <h2 className="lws-title">{title}</h2>
                <div className="job-footers">
                    <div className="lws-type">
                        {/* <!-- Fulltime - #FF8A00,  --><!-- Internship - #FF5757,  --><!-- Remote - #56E5C4,  --> */}
                        <i style={{ color: background }} className="fa-solid fa-stop text-lg mr-1.5"></i>
                        {type}
                    </div>
                    <div className="lws-salary">
                        <i className="fa-solid fa-bangladeshi-taka-sign text-slate-400 text-lg mr-1.5"></i>
                        BDT {salary}
                    </div>
                    <div className="lws-deadline">
                        <i className="fa-regular fa-calendar text-slate-400 text-lg mr-1.5"></i>
                        Closing on {deadline}
                    </div>
                </div>
            </div>
            <div className="mt-5 flex lg:mt-0 lg:ml-4">
                <span className="hidden sm:block">
                    <Link to={`/edit-job/${id}`}><button type="button" className="lws-edit btn btn-primary">
                        <i className="fa-solid fa-pen text-gray-300 -ml-1 mr-2"></i>
                        Edit
                    </button></Link>
                </span>

                <span className="sm:ml-3">
                    <button onClick={deleteJobInfo} type="button" className="lws-delete btn btn-danger ">
                        <i className="fa-solid fa-trash text-gray-300 -ml-1 mr-2"></i>
                        Delete
                    </button>
                </span>
            </div>
        </div>
    )
}
